/**
 * Shopify storefront chat widget – session persistence (sessionStorage: shopChatSession).
 * DOM: #chat-bubble-root, #chat-window, intake form, thread, etc. Requires window.DashboardChatCore.
 * Panel motion is injected here so themes cannot snap-open the panel with display toggles alone.
 */
(function () {
    'use strict';

    var STORAGE_KEY = 'shopChatSession';
    var PANEL_STYLE_ID = 'asgard-chat-panel-motion';

    /** Inject once: forces slide/fade so old asgard-chat.css can't snap */
    function injectPanelMotionStyles() {
        if (document.getElementById(PANEL_STYLE_ID)) return;
        var css = [
            '#chat-bubble-root{position:fixed!important;right:32px!important;bottom:32px!important;z-index:999999!important;pointer-events:none!important}',
            '#chat-bubble-root .chat-toggle-btn,#chat-bubble-root #chat-window{pointer-events:auto!important}',
            '#chat-window{',
            'display:flex!important;flex-direction:column!important;overflow:hidden!important;',
            'position:absolute!important;right:0!important;bottom:calc(64px + 8px)!important;',
            'width:380px!important;height:560px!important;max-height:72vh!important;min-height:360px!important;',
            'opacity:0!important;transform:translateY(24px)!important;',
            'visibility:hidden!important;pointer-events:none!important;',
            'transition:opacity .28s cubic-bezier(.25,.46,.45,.94),transform .32s cubic-bezier(.25,.46,.45,.94),visibility 0s linear .32s!important',
            '}',
            '#chat-window.open{',
            'opacity:1!important;transform:translateY(0)!important;',
            'visibility:visible!important;pointer-events:auto!important;',
            'transition:opacity .3s cubic-bezier(.25,.46,.45,.94),transform .34s cubic-bezier(.25,.46,.45,.94),visibility 0s linear 0s!important',
            '}',
            '@media (prefers-reduced-motion:reduce){#chat-window,#chat-window.open{transition-duration:.01ms!important}}'
        ].join('');
        var el = document.createElement('style');
        el.id = PANEL_STYLE_ID;
        el.textContent = css;
        document.head.appendChild(el);
    }

    function getStoredSession() {
        try {
            var raw = sessionStorage.getItem(STORAGE_KEY);
            if (!raw) return null;
            var data = JSON.parse(raw);
            if (data && data.sessionId) return data;
        } catch (e) {}
        return null;
    }

    function saveSession(sessionId, name, email) {
        try {
            var isOpen = win && win.classList.contains('open');
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
                sessionId: sessionId,
                name: name || '',
                email: email || '',
                windowOpen: !!isOpen
            }));
        } catch (e) {}
    }

    function clearSession() {
        try {
            sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
    }

    var toggle = document.getElementById('chat-toggle-btn');
    var win = document.getElementById('chat-window');
    var form = document.getElementById('chat-intake-form');
    var successEl = document.getElementById('chat-intake-success');
    var errorEl = document.getElementById('chat-intake-error');
    var threadEl = document.getElementById('chat-thread');
    var threadBody = win ? win.querySelector('.chat-window-body') : null;
    var messagesListEl = document.getElementById('chat-messages-list');
    var threadForm = document.getElementById('chat-thread-form');
    var threadInput = document.getElementById('chat-thread-input');

    var currentSessionId = null;
    var currentName = '';
    var currentEmail = '';
    var unsubMessages = null;

    function renderMessages(list) {
        if (!messagesListEl) return;
        messagesListEl.innerHTML = '';
        (list || []).forEach(function (msg) {
            var role = (msg.role || 'user');
            var isCustomer = role === 'user' && (msg.meta && (msg.meta.origin === 'shop-front' || msg.meta.source === 'shop-front'));
            var div = document.createElement('div');
            div.className = 'chat-msg ' + (isCustomer ? 'customer' : 'agent');
            var bubble = document.createElement('div');
            bubble.className = 'chat-msg-bubble';
            if (msg.text) {
                var textEl = document.createElement('div');
                textEl.className = 'chat-msg-caption';
                textEl.textContent = msg.text || '';
                bubble.appendChild(textEl);
            }
            div.appendChild(bubble);
            messagesListEl.appendChild(div);
        });
        messagesListEl.scrollTop = messagesListEl.scrollHeight;
    }

    function showThreadView(sessionId, name, email, saveToStorage) {
        currentSessionId = sessionId;
        currentName = name || '';
        currentEmail = email || '';
        if (saveToStorage !== false) saveSession(sessionId, currentName, currentEmail);
        if (successEl) successEl.style.display = 'none';
        if (form) form.style.display = 'none';
        if (threadBody) threadBody.classList.add('has-thread');
        if (threadEl) threadEl.style.display = 'flex';
        renderMessages([]);
        if (unsubMessages && typeof unsubMessages === 'function') {
            unsubMessages();
            unsubMessages = null;
        }
        if (window.DashboardChatCore && window.DashboardChatCore.onMessagesForSession) {
            unsubMessages = window.DashboardChatCore.onMessagesForSession(sessionId, function (list) {
                renderMessages(list);
                if (typeof ackMessages === 'function') ackMessages(list);
            });
        }
        if (typeof startSessionSideEffects === 'function') startSessionSideEffects();
    }

    function showError(msg) {
        if (errorEl) {
            errorEl.textContent = msg || 'Something went wrong. Please try again.';
            errorEl.style.display = 'block';
        }
        if (successEl) successEl.style.display = 'none';
    }

    function showSuccess() {
        if (errorEl) errorEl.style.display = 'none';
        if (successEl) successEl.style.display = 'block';
        if (form) form.style.display = 'none';
    }

    function hideSuccess() {
        if (successEl) successEl.style.display = 'none';
        if (form) form.style.display = 'block';
    }

    function resetToIntake() {
        currentSessionId = null;
        if (unsubMessages && typeof unsubMessages === 'function') {
            unsubMessages();
            unsubMessages = null;
        }
        clearSession();
        if (threadEl) threadEl.style.display = 'none';
        if (threadBody) threadBody.classList.remove('has-thread');
        if (form) form.style.display = '';
        if (successEl) successEl.style.display = 'none';
        if (win) win.classList.remove('open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function tryRestoreSession() {
        var stored = getStoredSession();
        if (!stored || !stored.sessionId) return;
        if (!window.DashboardChatCore || typeof window.DashboardChatCore.readOwnedSession !== 'function') return;
        ensureShopChatAuthUser().then(function (user) {
            return window.DashboardChatCore.readOwnedSession(stored.sessionId, user.uid).then(function (owned) {
                if (!owned) {
                    resetToIntake();
                    return;
                }
                injectPanelMotionStyles();
                showThreadView(stored.sessionId, stored.name, stored.email, false);
                if (win && stored.windowOpen !== false) {
                    win.classList.add('open');
                    if (toggle) toggle.setAttribute('aria-expanded', 'true');
                }
            });
        }).catch(function () {});
    }

    function applyPrefill() {
        var prefill = window.ASGARD_CHAT_PREFILL;
        if (!form || !prefill || typeof prefill !== 'object') return;
        var nameEl = form.elements['name'];
        var emailEl = form.elements['email'];
        if (nameEl && prefill.name != null && String(prefill.name).trim() !== '') nameEl.value = String(prefill.name).trim();
        if (emailEl && prefill.email != null && String(prefill.email).trim() !== '') emailEl.value = String(prefill.email).trim();
    }

    if (toggle && win) {
        injectPanelMotionStyles();
        toggle.addEventListener('click', function () {
            win.classList.toggle('open');
            toggle.setAttribute('aria-expanded', win.classList.contains('open') ? 'true' : 'false');
            if (currentSessionId) saveSession(currentSessionId, currentName, currentEmail);
            if (typeof publishPresence === 'function') publishPresence();
            if (currentSessionId && window.DashboardChatCore && window.DashboardChatCore.getMessagesForSession && typeof ackMessages === 'function') {
                ackMessages(window.DashboardChatCore.getMessagesForSession(currentSessionId));
            }
        });
        toggle.setAttribute('aria-expanded', win.classList.contains('open') ? 'true' : 'false');
    }

    function ensureShopChatAuthUser() {
        if (!window.auth || typeof window.auth.signInAnonymously !== 'function') {
            var u = new Error('AUTH_UNAVAILABLE');
            u.code = 'auth/chat-widget-no-auth';
            return Promise.reject(u);
        }
        if (window.auth.currentUser) {
            return Promise.resolve(window.auth.currentUser);
        }
        return new Promise(function (resolve, reject) {
            var settled = false;
            var timeoutId = null;
            var unsub = null;
            function cleanup() {
                if (timeoutId != null) clearTimeout(timeoutId);
                if (typeof unsub === 'function') unsub();
            }
            function ok(user) {
                if (settled || !user) return;
                settled = true;
                cleanup();
                resolve(user);
            }
            function fail(err) {
                if (settled) return;
                settled = true;
                cleanup();
                reject(err || new Error('AUTH_FAILED'));
            }
            unsub = window.auth.onAuthStateChanged(function (user) {
                if (user) ok(user);
            });
            timeoutId = setTimeout(function () {
                if (settled) return;
                window.auth.signInAnonymously().then(function (cred) {
                    if (cred && cred.user) ok(cred.user);
                    else fail(new Error('AUTH_EMPTY'));
                }).catch(fail);
            }, 400);
        });
    }

    if (form && window.DashboardChatCore && typeof window.DashboardChatCore.createSession === 'function' && typeof window.DashboardChatCore.sendUserMessage === 'function') {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            if (errorEl) errorEl.style.display = 'none';
            var submitBtn = form.querySelector('button[type="submit"]');
            if (submitBtn) submitBtn.disabled = true;
            var nameEl = form.elements['name'];
            var emailEl = form.elements['email'];
            var messageEl = form.elements['message'];
            var name = (nameEl && nameEl.value) ? nameEl.value.trim() : '';
            var email = (emailEl && emailEl.value) ? emailEl.value.trim() : '';
            var message = (messageEl && messageEl.value) ? messageEl.value.trim() : '';

            var text = message || ('New chat request from ' + name + ' <' + email + '>');

            function doCreateSession(uid) {
                window.DashboardChatCore.createSession({
                    customerName: name,
                    customerEmail: email,
                    customerUid: uid || null,
                    originalContext: typeof readPageContext === 'function' ? readPageContext() : null
                }).then(function (sessionId) {
                    if (sessionId) {
                        window.DashboardChatCore.sendUserMessage(text, {
                            sessionId: sessionId,
                            origin: 'shop-front',
                            source: 'shop-front',
                            name: name,
                            email: email
                        });
                        form.reset();
                        showThreadView(sessionId, name, email);
                    } else {
                        showError('Could not start chat. Make sure you\'re online and try again.');
                    }
                    if (submitBtn) submitBtn.disabled = false;
                }).catch(function (err) {
                    var msg = (err && (err.message || err.code)) ? ('Could not start chat: ' + (err.message || err.code)) : 'Could not start chat. Please try again.';
                    showError(msg);
                    if (submitBtn) submitBtn.disabled = false;
                });
            }

            ensureShopChatAuthUser().then(function (user) {
                doCreateSession(user.uid);
            }).catch(function (err) {
                var code = err && err.code;
                if (err && err.code === 'auth/chat-widget-no-auth') {
                    showError('Chat couldn’t sign you in. Check that Firebase scripts loaded (network), then refresh.');
                } else if (code === 'auth/admin-restricted-operation' || code === 'auth/operation-not-allowed') {
                    showError('Chat couldn’t sign you in. In Firebase Console → Authentication → Sign-in method, enable Anonymous.');
                } else if (code === 'auth/unauthorized-domain') {
                    showError('Chat couldn’t sign you in. Add this site’s domain under Firebase Console → Authentication → Settings → Authorized domains.');
                } else {
                    showError('Chat couldn’t sign you in. Try a normal (non-private) window, allow cookies, or allow third-party cookies for this shop.');
                }
                if (submitBtn) submitBtn.disabled = false;
            });
        });
    } else if (errorEl && (!window.DashboardChatCore || !window.DashboardChatCore.createSession)) {
        errorEl.textContent = 'Chat is not connected. Check that Firebase loaded (console) and chat-core.js is in your theme assets.';
        errorEl.style.display = 'block';
    }

    if (threadForm && threadInput && window.DashboardChatCore && window.DashboardChatCore.sendUserMessage) {
        threadForm.addEventListener('submit', function (e) {
            e.preventDefault();
            var text = (threadInput.value || '').trim();
            if (!text || !currentSessionId) return;
            window.DashboardChatCore.sendUserMessage(text, {
                sessionId: currentSessionId,
                origin: 'shop-front',
                source: 'shop-front',
                name: currentName,
                email: currentEmail
            });
            threadInput.value = '';
        });
    }

    var TAB_KEY = 'asgardChatTabId';
    var HEARTBEAT_MS = 30000;
    var AWAY_MS = 120000;
    var contextTimer = null;
    var heartbeatTimer = null;
    var lastContextSignature = '';
    var lastContextWriteAt = 0;
    var lastActivityAt = Date.now();
    var deliveredIds = {};
    var seenIds = {};
    var presenceHeartbeatStarted = false;
    var presenceSkipLogged = {};

    function logPresenceSkip(reason) {
        if (presenceSkipLogged[reason]) return;
        presenceSkipLogged[reason] = true;
        if (typeof console !== 'undefined' && console.warn) console.warn('Chat presence skipped: ' + reason);
    }

    function tabId() {
        try {
            var existing = sessionStorage.getItem(TAB_KEY);
            if (existing && /^[A-Za-z0-9]{8,32}$/.test(existing)) return existing;
            var next = Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10);
            next = next.replace(/[^A-Za-z0-9]/g, '').slice(0, 20);
            if (next.length < 8) next = ('tab' + Date.now().toString(36)).slice(0, 12);
            sessionStorage.setItem(TAB_KEY, next);
            return next;
        } catch (e) {
            return 'tabfallback1';
        }
    }

    function cleanText(value, max) {
        return String(value == null ? '' : value).replace(/[<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, max);
    }

    function cleanUrl(value) {
        var url = cleanText(value, 500);
        if (!url || url.indexOf('//') === 0) return '';
        if (/^https?:\/\//i.test(url) || url.charAt(0) === '/') return url;
        return '';
    }

    function readPageContext() {
        var loc = window.location;
        var url = cleanUrl(loc.origin + loc.pathname + loc.search);
        var liquid = window.ASGARD_CHAT_PAGE || {};
        var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
        var product = meta && meta.product;
        var liquidUrl = cleanUrl(liquid.url || '');
        var samePage = !liquidUrl || liquidUrl === url || url.indexOf(liquidUrl) !== -1;
        var variantNode = document.querySelector('form[action*="/cart/add"] [name="id"], select[name="id"], input[name="id"]');
        var variantId = variantNode && variantNode.value ? cleanText(variantNode.value, 40) : '';
        if (!variantId && meta && meta.selectedVariantId) variantId = cleanText(meta.selectedVariantId, 40);
        if (!variantId && samePage && liquid.variantId) variantId = cleanText(liquid.variantId, 40);
        var productId = product && product.id ? cleanText(product.id, 40) : '';
        if (!productId && samePage && liquid.productId) productId = cleanText(liquid.productId, 40);
        var productTitle = '';
        if (productId && samePage && liquid.productTitle && cleanText(liquid.productId, 40) === productId) {
            productTitle = cleanText(liquid.productTitle, 200);
        }
        var variantTitle = '';
        var options = '';
        if (product && product.variants && variantId) {
            for (var i = 0; i < product.variants.length; i++) {
                if (cleanText(product.variants[i].id, 40) === variantId) {
                    variantTitle = cleanText(product.variants[i].public_title || product.variants[i].name || '', 200);
                    options = variantTitle;
                    break;
                }
            }
        }
        if (!variantTitle && samePage && liquid.variantId && cleanText(liquid.variantId, 40) === variantId) {
            variantTitle = cleanText(liquid.variantTitle, 200);
            options = cleanText([liquid.option1, liquid.option2, liquid.option3].filter(Boolean).join(' / '), 200) || variantTitle;
        }
        var title = cleanText(document.title || liquid.title || '', 200);
        return {
            pageType: productId ? 'product' : cleanText((samePage && liquid.pageType) || 'page', 40),
            url: url,
            title: title,
            productId: productId,
            productHandle: samePage ? cleanText(liquid.productHandle, 120) : '',
            productTitle: productTitle,
            variantId: productId ? variantId : '',
            variantTitle: productId ? variantTitle : '',
            options: productId ? options : ''
        };
    }

    function contextSignature(context) {
        return [context.pageType, context.url, context.title, context.productId, context.productHandle, context.productTitle, context.variantId, context.variantTitle, context.options].join('\n');
    }

    function publishContext(force) {
        if (!currentSessionId || !window.DashboardChatCore || !window.DashboardChatCore.updateCurrentContext) return;
        var context = readPageContext();
        var signature = contextSignature(context);
        var nowMs = Date.now();
        if (!force && signature === lastContextSignature && nowMs - lastContextWriteAt < 15000) return;
        if (signature === lastContextSignature && !force) return;
        lastContextSignature = signature;
        lastContextWriteAt = nowMs;
        window.DashboardChatCore.updateCurrentContext(currentSessionId, context);
    }

    function scheduleContext() {
        if (contextTimer) clearTimeout(contextTimer);
        contextTimer = setTimeout(function () { publishContext(false); }, 400);
    }

    function widgetOpen() {
        return !!(win && win.classList.contains('open'));
    }

    function pageVisible() {
        return !document.hidden && document.visibilityState !== 'hidden';
    }

    function customerActive() {
        return pageVisible() && (Date.now() - lastActivityAt) < AWAY_MS;
    }

    function publishPresence() {
        if (!currentSessionId) return;
        if (!window.auth || !window.auth.currentUser) {
            logPresenceSkip('no-auth');
            return;
        }
        if (!window.DashboardChatCore || typeof window.DashboardChatCore.upsertPresence !== 'function') {
            logPresenceSkip('no-writer');
            return;
        }
        var pending = window.DashboardChatCore.upsertPresence({
            sessionId: currentSessionId,
            tabId: tabId(),
            customerUid: window.auth.currentUser.uid,
            connectionState: customerActive() ? 'online' : 'away',
            widgetState: widgetOpen() ? 'open' : 'minimized',
            active: customerActive()
        });
        if (pending && typeof pending.then === 'function') pending.then(function () {}, function () {});
    }

    function ackMessages(list) {
        if (!currentSessionId || !window.auth || !window.auth.currentUser || !window.DashboardChatCore || !window.DashboardChatCore.ackStaffMessage) return;
        var uid = window.auth.currentUser.uid;
        var seen = widgetOpen() && pageVisible();
        (list || []).forEach(function (msg) {
            var fromStaff = msg.role === 'assistant' || (msg.meta && (msg.meta.origin === 'dashboard' || msg.meta.source === 'dashboard'));
            var fromCustomer = msg.role === 'user' && msg.meta && (msg.meta.origin === 'shop-front' || msg.meta.source === 'shop-front');
            if (!msg.id || fromCustomer || !fromStaff) return;
            if (!deliveredIds[msg.id]) {
                deliveredIds[msg.id] = true;
                window.DashboardChatCore.ackStaffMessage(msg.id, currentSessionId, uid, 'delivered');
            }
            if (seen && !seenIds[msg.id]) {
                seenIds[msg.id] = true;
                window.DashboardChatCore.ackStaffMessage(msg.id, currentSessionId, uid, 'seen');
            }
        });
    }

    function watchCustomerState() {
        ['mousemove', 'keydown', 'pointerdown', 'scroll', 'touchstart'].forEach(function (name) {
            window.addEventListener(name, function () {
                lastActivityAt = Date.now();
            }, { passive: true });
        });
        document.addEventListener('visibilitychange', function () {
            if (!document.hidden) lastActivityAt = Date.now();
            publishPresence();
            if (currentSessionId && window.DashboardChatCore && window.DashboardChatCore.getMessagesForSession) {
                ackMessages(window.DashboardChatCore.getMessagesForSession(currentSessionId));
            }
        });
        window.addEventListener('popstate', scheduleContext);
        document.addEventListener('change', function (event) {
            var target = event.target;
            if (target && target.name === 'id') scheduleContext();
        });
        document.addEventListener('variant:change', scheduleContext);
        if (window.history && !window.history.__asgardChatWrapped) {
            ['pushState', 'replaceState'].forEach(function (name) {
                var original = window.history[name];
                if (typeof original !== 'function') return;
                window.history[name] = function () {
                    var result = original.apply(this, arguments);
                    scheduleContext();
                    return result;
                };
            });
            window.history.__asgardChatWrapped = true;
        }
        if (!presenceHeartbeatStarted) {
            presenceHeartbeatStarted = true;
            if (typeof console !== 'undefined' && console.info) console.info('Chat presence heartbeat scheduled');
        }
        heartbeatTimer = setInterval(function () {
            publishPresence();
            publishContext(false);
        }, HEARTBEAT_MS);
    }

    function startSessionSideEffects() {
        publishContext(true);
        publishPresence();
    }

    function init() {
        injectPanelMotionStyles();
        tryRestoreSession();
        applyPrefill();
        watchCustomerState();
        if (currentSessionId) {
            ensureShopChatAuthUser().then(function () {
                startSessionSideEffects();
            }).catch(function () {});
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.ShopChatWidget = {
        clearSession: clearSession,
        getStoredSession: getStoredSession
    };
})();